import { Box } from "@mui/material";
import { colors } from "common";
import React, { FC, useEffect, useState } from "react";

interface Props {
  count?: number;
  onCountComplete?: () => void; // any intended
}

export const CountdownBar: FC<Props> = ({ count = 10000, onCountComplete }) => {
  const [progress, setProgress] = useState(count);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        const newProgress = oldProgress - 1000;
        if (newProgress <= 0) {
          setTimeout(
            () => onCountComplete(),
            1000 // Delay to sync call custom function after interval is done
          );
          return 0;
        }
        return newProgress > 0 ? newProgress : 0;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [onCountComplete]);

  return (
    <Box sx={{ width: "100%", mb: "-.4em", mt: ".5em" }}>
      <Box
        sx={{
          width: "100%",
          height: "2px",
          position: "relative",
          borderRadius: "5px",
        }}
      >
        <Box
          sx={{
            height: "100%",
            backgroundColor: colors.primary,
            width: `${(progress / count) * 100}%`,
            transition: "width 1s linear",
            borderRadius: "3px",
          }}
        />
      </Box>
    </Box>
  );
};
